export class ResponseDefine{
    constructor(){
        this.method ="";
        this.data ="";
    }
    method: string;
    data: string;
}